<template>
  <div id="app">
    <component :is="layout"></component>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  data() {
    return {};
  },
  computed: {
    layout() {
      return this.$route.meta.layout || 'DefaultLayout';
    }
  },
  async created() {
    this.fetchViews();
    window.addEventListener('resize', (e) => {
      this.$bus.emit('global.window.resize', {
        width: e.target.offsetWidth,
        height: e.target.offsetHeight
      });
    });
  },
  methods: {
    ...mapActions({
      fetchViews: 'views/fetchViews'
    }),
    async request() {
      let result = await this.$http.get('/home/banner?type=1&category=18');
      console.log('result:', result);
    }
  }
};
</script>

<style lang="scss">
html,
body {
  min-width: 1280px;
  min-height: 730px;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  height: 100vh;
  position: relative;
}
</style>
